import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Button,
  Select,
  Grid,
  Box,
  Typography,
  Chip,
} from '@mui/material';
import LoaderComponent from '../../../components/Loader/LoaderComponent';
import DateRangeComponent from '../../../components/DateRangePicker/DateRangeComponent';
import '../../../App.css';
import './LeaveApplication.css';
import {
  SUBJECT_PLACEHOLDER,
  LEAVE_TYPE_LABEL,
  SUBJECT_LABEL,
  CASUAL_LEAVE,
  SICK_LEAVE,
  MISCELLANEOUS_LEAVE,
  WFH,
  NO_SUBJECT_ERROR_LABEL,
} from '../LeavesConstants';
import { leaveType as leaveTypeConverter } from '../LeavesConstants';
import {
  CANCEL_BUTTON_TEXT,
  ERROR_KEY,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
} from '../../../constants';
import moment from 'moment';
import KeycloakService from '../../../services/KeycloakService';
import {
  getUserLeavesSummaryByYear,
  getUserLeavesSummary,
  getUsers,
  getUserData,
  isSoleProjectManager,
} from '../../../services/UserService';
import { applyLeave, getLeaveTypeList } from '../../../services/LeaveService';
import { useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { isQuarterlyCasualAccounting } from '../../../utils/casualLeaveUtils';
import { getCasualLeaveAccounting } from '../../../services/CasualLeaveAccountingService';
const LeaveApplicationComponent = (props) => {
  const {
    editableLeave,
    closeFunction,
    getLeaveList,
    getLeavesSummary,
    editable,
    editRecipients,
    presetRecipients,
    officialHolidays,
  } = props;
  const [loader, setLoader] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [toSubjects, setToSubjects] = React.useState([]);
  const [leaveType, setLeaveType] = React.useState('');
  const [recipients, setRecipients] = React.useState([...presetRecipients]);
  const [dateRange, setDateRange] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [leaveReason, setLeaveReason] = React.useState('');
  const [leaveError, setLeaveError] = React.useState(false);
  const [leaveTypeError, setLeaveTypeError] = React.useState(false);
  const [noSubjectError, setNoSubjectError] = React.useState(false);
  const [search, setSearch] = React.useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const dispatch = useDispatch();
  const [leaveTypeList, setLeaveTypeList] = useState([
    { leaveName: CASUAL_LEAVE },
  ]);
  const [officeLocationId, setOfficeLocationId] = useState();
  const currentUserId = () => KeycloakService.getUserDetail();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [reportingManagerRecipient, setReportingManagerRecipient] =
    useState(null);
  const [
    isSoleProjectManagerOnActiveProject,
    setIsSoleProjectManagerOnActiveProject,
  ] = useState(false);
  const [approvalRoutingResolved, setApprovalRoutingResolved] = useState(false);

  const isOneDayLeave = (range) => {
    const start = moment(range.startDate).format('YYYY-MM-DD');
    const end = moment(range.endDate).format('YYYY-MM-DD');
    return start === end;
  };

  const buildReportingManagerRecipient = (userData) => {
    if (!userData?.reportingManagerId) {
      return null;
    }
    const displayName = (userData.reportingManagerDisplayName || '').trim();
    const nameParts = displayName ? displayName.split(/\s+/) : [];
    return {
      id: userData.reportingManagerId,
      firstName: nameParts[0] || 'Reporting',
      lastName: nameParts.slice(1).join(' ') || 'Manager',
      emailId: userData.reportingManagerEmail,
    };
  };

  const syncRecipientsForDateRange = (
    range,
    rmRecipient,
    pmRecipients,
    soleProjectManager = isSoleProjectManagerOnActiveProject,
  ) => {
    if (isOneDayLeave(range) && !soleProjectManager) {
      setRecipients([...(pmRecipients || presetRecipients)]);
    } else {
      setRecipients(rmRecipient ? [rmRecipient] : []);
    }
  };

  useEffect(() => {
    loadData();
    getLeavesWfhSummary();
  }, []);

  useEffect(() => {
    if (editable) {
      return;
    }
    syncRecipientsForDateRange(
      dateRange,
      reportingManagerRecipient,
      presetRecipients,
    );
  }, [
    dateRange.startDate,
    dateRange.endDate,
    reportingManagerRecipient,
    presetRecipients,
    isSoleProjectManagerOnActiveProject,
  ]);

  const errorLeave = () => {
    setLeaveError(true);
  };

  const errorNoSubject = () => {
    setNoSubjectError(true);
  };

  const getLeavesWfhSummary = async () => {
    const leaveSummary = await getUserLeavesSummaryByYear(
      currentUserId(),
      selectedYear,
    );
    const leaveList = await getLeaveTypeList(selectedYear);

    if (leaveSummary.isError === false && leaveList.isError === false) {
      const filteredLeaveList = leaveList.data
        .filter((leave) => leave.leaveCategoryId === 1)
        .map((leave) => {
          const leaveRecord = leaveSummary.data.data.leavesRecordDTOList.find(
            (record) => record.leaveId === leave.id,
          );
          return {
            leaveName: leave.leaveName,
            leaveCategoryId: leave.leaveCategoryId,
            ...leaveRecord,
          };
        })
        .filter((item) => item.leaveId);
      setLeaveTypeList(filteredLeaveList);

    }
  };
  const loadData = async () => {
    const user = await getUserData(currentUserId());
    const soleProjectManagerResponse =
      await isSoleProjectManager(currentUserId());
    if (user.isError || soleProjectManagerResponse.isError) {
      dipatchNotification(
        user.isError ? user.type : soleProjectManagerResponse.type,
        user.isError ? user.message : soleProjectManagerResponse.message,
      );
      return;
    }
    const soleProjectManager = Boolean(soleProjectManagerResponse.data?.data);
    setIsSoleProjectManagerOnActiveProject(soleProjectManager);
    setApprovalRoutingResolved(true);
    if (user.data.locationId) {
      setOfficeLocationId(user.data.locationId);
    }
    const rmRecipient = buildReportingManagerRecipient(user.data);
    setReportingManagerRecipient(rmRecipient);
    const subjects = await getUsers('');
    if (subjects.status !== 200) {
      dipatchNotification(subjects.type, subjects.message);
    }
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.content);
    }
    recipientField(rmRecipient, soleProjectManager);
    if (!editable) {
      syncRecipientsForDateRange(
        dateRange,
        rmRecipient,
        presetRecipients,
        soleProjectManager,
      );
    }
  };

  const editLeave = (
    leave,
    editRecipients,
    rmRecipient = reportingManagerRecipient,
    soleProjectManager = isSoleProjectManagerOnActiveProject,
  ) => {
    const range = editRange(leave);
    setLeaveReason(leave.reason);
    setLeaveType(leave.leaveId);
    setDateRange(range);
    if (isOneDayLeave(range) && !soleProjectManager) {
      const arr = presetRecipients.map((val) => val.id);
      setRecipients(() => [
        ...presetRecipients,
        ...editRecipients.filter((val) => !arr.includes(val.id)),
      ]);
    } else {
      setRecipients(rmRecipient ? [rmRecipient] : []);
    }
  };

  const onDateRangeSelection = (item) => {
    const nextRange = {
      startDate: item.startDate,
      endDate: item.endDate,
    };
    setDateRange((data) => {
      return {
        ...data,
        ...nextRange,
      };
    });
    if (editable) {
      syncRecipientsForDateRange(
        nextRange,
        reportingManagerRecipient,
        presetRecipients,
      );
    }
  };

  const editRange = (leave) => {
    return {
      startDate: new Date(leave.startDate),
      endDate: new Date(leave.endDate),
    };
  };

  const recipientField = async (
    rmRecipient = reportingManagerRecipient,
    soleProjectManager = isSoleProjectManagerOnActiveProject,
  ) => {
    if (editable) {
      editLeave(editableLeave, editRecipients, rmRecipient, soleProjectManager);
    }
  };

  const editLeaveFunction = async () => {
    const updatedLeavePayload = editLeavePayload();
    if (!updatedLeavePayload) return;
    const leaveResponse = await applyLeave(
      updatedLeavePayload,
      officeLocationId,
    );
    setLoading(false);
    dipatchNotification(leaveResponse.type, leaveResponse.message);
    if (leaveResponse.isError === false) {
      closeFunction();
      getLeaveList();
      if (getLeavesSummary) {
        getLeavesSummary();
      }
    }
  };

  const editLeavePayload = () => {
    //    if (recipients.length < 1) {
    // errorNoSubject();
    //      return true;
    //    }
    if (leaveReason === '') {
      errorLeave();
      return false;
    } else {
      setLoading(true);
      setLeaveError(false);
      setNoSubjectError(false);
      const startDate = moment(dateRange.startDate).format('YYYY-MM-DD');
      const endDate = moment(dateRange.endDate).format('YYYY-MM-DD');
      const oneDay = startDate === endDate;
      return {
        id: editableLeave.id,
        employeeId: currentUserId(),
        type: 'leave',
        leaveId: leaveType,
        reason: leaveReason,
        status: 'PENDING',
        isUpdatedByAdmin: false,
        startDate,
        endDate,
        // Backend overwrites recipients for multi-day leave with Reporting Manager.
        applicationStatusDTOS: oneDay
          ? recipients.map((recipient) => {
              return {
                type: 'leave',
                approverId: recipient.id,
                status: 'PENDING',
              };
            })
          : [],
      };
    }
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const fetchCasualLeaveAvailable = async (userId, year) => {
    const response = await getCasualLeaveAccounting(userId, year);
    const snapshot = response?.data?.data ?? response?.data;
    if (response?.isError === false && snapshot?.currentQuarterAvailable != null) {
      return snapshot.currentQuarterAvailable;
    }
    return null;
  };

  const applyLeaveFunction = async () => {
    const leavePayload = applyLeavePayload();

    if (!leavePayload) return;

    if (!(await enoughQuotaAvailable(leavePayload))) {
      setLoading(false);
      return;
    }

    const leaveResponse = await applyLeave(leavePayload, officeLocationId);
    setLoading(false);
    dipatchNotification(leaveResponse.type, leaveResponse.message);
    if (leaveResponse.isError === false) {
      closeFunction();
      getLeaveList();
      if (getLeavesSummary) {
        getLeavesSummary();
      }
    }
  };

  const enoughQuotaAvailable = async (payload) => {
    const startDate = new Date(payload.startDate + 'T00:00:00');
    const endDate = new Date(payload.endDate + 'T00:00:00');
    const leaveId = payload.leaveId;

    const sameYearLeaveSummary = await getUserLeavesSummaryByYear(
      currentUserId(),
      startDate.getFullYear(),
    );
    let differentYearLeaveSummary = null;

    // if start and end date years are same, check quota availability for that year only
    if (startDate.getFullYear() === endDate.getFullYear()) {
      const totalLeaveDays = calculateLeaveDays(
        startDate,
        endDate,
        officialHolidays,
      );

      const leaveRecord =
        sameYearLeaveSummary?.data?.data?.leavesRecordDTOList.find(
          (record) => record.leaveId === leaveId,
        );

      const isCasualAccounting = isQuarterlyCasualAccounting(leaveRecord);

      if (!isCasualAccounting) {
        const remainingLeaveQuota =
          leaveRecord?.totalAllowedLeaves - leaveRecord?.usedLeaves;

        if (totalLeaveDays > remainingLeaveQuota) {
          dipatchNotification(
            ERROR_KEY,
            `Insufficient leave quota for this leave type. Please contact HR to get Unpaid Time Off.`,
          );
          return false;
        }
      }

      // Soft quarterly pre-check for grouped Casual Leave; backend accounting gate is authoritative.
      if (isCasualAccounting) {
        const quarterlyAvailable = await fetchCasualLeaveAvailable(
          currentUserId(),
          startDate.getFullYear(),
        );
        if (quarterlyAvailable != null && totalLeaveDays > quarterlyAvailable) {
          dipatchNotification(
            ERROR_KEY,
            `Leave exceeds the current quarter casual leave quota.`,
          );
          return false;
        }
      }
    } else {
      // if start and end date years are different, check quota availability for both years
      differentYearLeaveSummary = await getUserLeavesSummaryByYear(
        currentUserId(),
        endDate.getFullYear(),
      );
      const endOfStartYear = new Date(startDate.getFullYear(), 11, 31);
      const startOfEndYear = new Date(endDate.getFullYear(), 0, 1);

      const leaveDaysInStartYear = calculateLeaveDays(
        startDate,
        endOfStartYear,
        officialHolidays,
      );

      const leaveDaysInEndYear = calculateLeaveDays(
        startOfEndYear,
        endDate,
        officialHolidays,
      );

      const leaveRecordStartYear =
        sameYearLeaveSummary?.data?.data?.leavesRecordDTOList.find(
          (record) => record.leaveId === leaveId,
        );

      const leaveRecordEndYear =
        differentYearLeaveSummary?.data?.data?.leavesRecordDTOList.find(
          (record) => record.leaveId === leaveId,
        );

      const isCasualAccounting =
        isQuarterlyCasualAccounting(leaveRecordStartYear) ||
        isQuarterlyCasualAccounting(leaveRecordEndYear);

      if (!isCasualAccounting) {
        const remainingQuotaStartYear =
          leaveRecordStartYear.totalAllowedLeaves -
          leaveRecordStartYear.usedLeaves;
        const remainingQuotaEndYear = leaveRecordEndYear
          ? leaveRecordEndYear.totalAllowedLeaves - leaveRecordEndYear.usedLeaves
          : 0;

        if (
          leaveDaysInStartYear > remainingQuotaStartYear ||
          leaveDaysInEndYear > remainingQuotaEndYear
        ) {
          dipatchNotification(
            ERROR_KEY,
            `Insufficient leave quota for this leave type. Please contact HR to get Unpaid Time Off.`,
          );
          return false;
        }
      }

      if (isCasualAccounting) {
        const startAvailable = await fetchCasualLeaveAvailable(
          currentUserId(),
          startDate.getFullYear(),
        );
        const endAvailable = await fetchCasualLeaveAvailable(
          currentUserId(),
          endDate.getFullYear(),
        );
        if (
          (startAvailable != null && leaveDaysInStartYear > startAvailable) ||
          (endAvailable != null && leaveDaysInEndYear > endAvailable)
        ) {
          dipatchNotification(
            ERROR_KEY,
            `Leave exceeds the current quarter casual leave quota.`,
          );
          return false;
        }
      }
    }
    return true;
  };

  const calculateLeaveDays = (startDate, endDate, officialHolidays) => {
    let totalLeaveDays = 0;
    const holidaysSet = new Set(
      officialHolidays.map((date) => {
        const [day, month, year] = date.split(' ');
        const formattedDate = new Date(`${year}-${month}-${day}`);
        return formattedDate.toDateString();
      }),
    );

    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const dayOfWeek = currentDate.getDay();
      const formattedDate = currentDate.toDateString();

      // Check if the current date is not a weekend and not a holiday
      if (
        dayOfWeek !== 0 &&
        dayOfWeek !== 6 &&
        !holidaysSet.has(formattedDate)
      ) {
        totalLeaveDays++;
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return totalLeaveDays;
  };

  const applyLeavePayload = () => {
    // if (recipients.length < 1) {
    //   // errorNoSubject();
    //   return true;
    // }
    if (leaveType === '') {
      setLeaveTypeError(() => true);
      return false;
    }
    if (leaveReason === '') {
      errorLeave();
      return false;
    } else {
      setLoading(true);
      setLeaveError(false);
      setNoSubjectError(false);
      const startDate = moment(dateRange.startDate).format('YYYY-MM-DD');
      const endDate = moment(dateRange.endDate).format('YYYY-MM-DD');
      const oneDay = startDate === endDate;
      return {
        employeeId: currentUserId(),
        type: 'leave',
        leaveId: leaveType,
        reason: leaveReason,
        status: 'PENDING',
        isUpdatedByAdmin: false,
        startDate,
        endDate,
        // Backend overwrites recipients for multi-day leave with Reporting Manager.
        applicationStatusDTOS: oneDay
          ? recipients.map((recipient) => {
              return {
                type: 'leave',
                approverId: recipient.id,
                status: 'PENDING',
              };
            })
          : [],
      };
    }
  };

  const checkOptions = (str) => {
    if (str?.length > 1) {
      setSearch(true);
    } else {
      setSearch(false);
    }
  };

  const handleCloseDropdown = (event) => {
    setSearch(false);
  };

  const style = {
    display: 'flex',
    '@media only screen and (max-width: 900px)': {
      '.apply-leaves-field': {
        width: '40%',
      },
      '.date-range-picker': {
        width: '60%',
      },
    },
    '@media only screen and (max-width: 700px)': {
      '.apply-leaves-field': {
        width: '40%',
      },
      '.date-range-picker': {
        width: '60%',
      },
      '.rdrMonth': {
        width: '100%',
      },
    },
    '@media only screen and (max-width: 580px)': {
      display: 'block',
      '.apply-leaves-field': {
        width: '100%',
      },
      '.date-range-picker': {
        width: '100%',
        justifyContent: 'center',
      },
      '.rdrMonth': {
        width: '100%',
      },
    },
  };

  return (
    <div>
      {loader ? (
        <div>
          <LoaderComponent loaderType="circular" />
        </div>
      ) : (
        <Box className="main-content-overlay" style={{ padding: '2% 5%' }}>
          <Autocomplete
            forcePopupIcon={false}
            multiple
            disableClearable
            id="multi-subjects"
            open={search}
            isOptionEqualToValue={(option, value) =>
              option.firstName + ' ' + option.lastName ===
              value.firstName + ' ' + value.lastName
            }
            options={toSubjects}
            getOptionLabel={(option) =>
              option.firstName + ' ' + option.lastName
            }
            onBlur={handleCloseDropdown}
            inputValue={inputValue}
            onInputChange={(e) => {
              const inputValue = e?.target?.value;
              setInputValue(inputValue);
              checkOptions(inputValue);
            }}
            value={recipients}
            onChange={(e, val) => {
              setRecipients((prevRecs) => [
                ...presetRecipients,
                ...val.filter(
                  (option) => presetRecipients.indexOf(option) === -1,
                ),
              ]);
              setInputValue('');
              setSearch(false);
            }}
            filterSelectedOptions
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip
                  key={index}
                  disabled={editable}
                  label={option.firstName + ' ' + option.lastName}
                  {...(presetRecipients.indexOf(option) === -1
                    ? getTagProps({ index })
                    : '')}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                error={noSubjectError}
                label={SUBJECT_LABEL}
                // placeholder={SUBJECT_PLACEHOLDER}
                helperText={noSubjectError ? NO_SUBJECT_ERROR_LABEL : ''}
                InputLabelProps={{
                  shrink: !(inputValue === '' && recipients.length === 0),
                }}
              />
            )}
            sx={{ mt: 2, height: '70px' }}
            disabled={true}
          />
          <Box sx={style}>
            <Grid
              container
              justifyContent="left"
              className="date-range-picker"
              sx={{ mt: 2, width: '45%' }}
            >
              {editable ? (
                <DateRangeComponent
                  officialHolidays={officialHolidays}
                  onDateRangeSelection={onDateRangeSelection}
                  minDate={
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth() - 6,
                      new Date().getDate(),
                    )
                  }
                />
              ) : (
                <DateRangeComponent
                  officialHolidays={officialHolidays}
                  onDateRangeSelection={onDateRangeSelection}
                  minDate={
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth() - 6,
                      new Date().getDate(),
                    )
                  }
                />
              )}
            </Grid>
            <Grid className="apply-leaves-field" sx={{ mt: 1, width: '55%' }}>
              <FormControl fullWidth sx={{ mt: 2 }} error={leaveTypeError}>
                <InputLabel>{LEAVE_TYPE_LABEL}</InputLabel>
                <Select
                  id="leave-type-select"
                  value={leaveType}
                  label="Leave Type"
                  onChange={(e) => {
                    setLeaveType(e.target.value);
                    setLeaveTypeError(false);
                  }}
                >
                  {leaveTypeList
                    .filter(
                      (item) =>
                        item.totalAllowedLeaves > 0 ||
                        isQuarterlyCasualAccounting(item),
                    )
                    .map((item, index) => (
                      <MenuItem key={index} value={item.leaveId}>
                        {item.leaveName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <TextField
                id="reason-field"
                label="Reason"
                multiline
                error={leaveError}
                fullWidth
                sx={{ mt: 2 }}
                value={leaveReason}
                onChange={(e) => {
                  setLeaveReason(e.target.value);
                  setLeaveError(false);
                }}
                rows={9}
              />
              {leaveError ? (
                <Typography variant="body2" color="error">
                  Please enter a reason for leave
                </Typography>
              ) : (
                ''
              )}
            </Grid>
          </Box>
          <div className="space-between-container">
            <Button variant="outlined" color="error" onClick={closeFunction}>
              {CANCEL_BUTTON_TEXT}
            </Button>
            <LoadingButton
              variant="contained"
              onClick={() => {
                editable ? editLeaveFunction() : applyLeaveFunction();
              }}
              loading={loading}
              disabled={
                !approvalRoutingResolved ||
                (isSoleProjectManagerOnActiveProject &&
                  !reportingManagerRecipient)
              }
            >
              {SUBMIT_BUTTON_TEXT}
            </LoadingButton>
          </div>
        </Box>
      )}
    </div>
  );
};

export default LeaveApplicationComponent;
